import React, { useState } from 'react';
import './CsvUpload.css';

export default function CsvUpload({ onImport, selectedSemesterId, selectedCourseTitle }) {
  const [csvData, setCsvData] = useState([]);
  const [mapping, setMapping] = useState({});

  const guessField = (header) => {
    const name = header.toLowerCase();
    if (name.includes('datum')) return 'course_date_from';
    if (name.includes('zeit')) return 'course_time';
    if (name.includes('raum')) return 'course_location';
    if (name.includes('dozent')) return 'course_lecturer';
    if (name.includes('ort')) return 'course_origin';
    if (name.includes('titel')) return 'course_title';
    return '';
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      alert('Keine Datei ausgewählt!');
      return;
    }

    const formData = new FormData();
    formData.append('csv_file', file);

    const res = await fetch('http://localhost/App/backend-web/upload.php', {
      method: 'POST',
      body: formData,
    });

    const text = await res.text();

    try {
      const data = JSON.parse(text);
      setCsvData(data);

      // Auto-Mapping
      const headerRow = data[0];
      const autoMap = {};
      headerRow.forEach((header, i) => {
        autoMap[i] = guessField(header);
      });
      setMapping(autoMap);
    } catch (err) {
      console.error('Antwort ist kein JSON:', text);
      alert('Fehler beim Verarbeiten der Datei.');
    }
  };

  const handleMappingChange = (colIndex, field) => {
    setMapping(prev => ({ ...prev, [colIndex]: field }));
  };

  const handleImport = async () => {
    const res = await fetch('http://localhost/App/backend-web/import.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        mapping,
        data: csvData.slice(1), // ohne Header-Zeile
        semesterId: selectedSemesterId,
        courseTitle: selectedCourseTitle,
      }),
    });

    const result = await res.json();
    alert(result.message);
    onImport();
  };

  return (
    <div className="csv-upload">
      <label>CSV-Datei hochladen:</label>
      <input type="file" accept=".csv" onChange={handleFileUpload} />

      {csvData.length > 0 && (
        <>
          <p><strong>Automatisch erkannte Zuordnung:</strong></p>
          <ul>
            {Object.entries(mapping).map(([index, field]) => (
              <li key={index}>
                Spalte {parseInt(index) + 1}: <code>{field || '–'}</code>
              </li>
            ))}
          </ul>

          <div className="csv-preview">
            <table>
              <thead>
                <tr>
                  {csvData[0].map((_, i) => (
                    <th key={i}>
                      <select value={mapping[i] || ''} onChange={(e) => handleMappingChange(i, e.target.value)}>
                        <option value="">-- Feld --</option>
                        <option value="course_title">Titel</option>
                        <option value="course_date_from">Datum</option>
                        <option value="course_time">Uhrzeit</option>
                        <option value="course_location">Raum</option>
                        <option value="course_lecturer">Dozent</option>
                        <option value="course_origin">Ort/Hochschule</option>
                      </select>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {csvData.slice(0, 10).map((row, i) => (
                  <tr key={i}>
                    {row.map((cell, j) => (
                      <td key={j}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <button onClick={handleImport}>Importieren</button>
          </div>
        </>
      )}
    </div>
  );
}
